var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9999 5.9375C13.4022 5.9375 12.107 7.1967 12.107 8.75C12.107 10.3033 13.4022 11.5625 14.9999 11.5625C16.5976 11.5625 17.8928 10.3033 17.8928 8.75C17.8928 7.1967 16.5976 5.9375 14.9999 5.9375ZM10.1785 8.75C10.1785 6.16117 12.3371 4.0625 14.9999 4.0625C17.6627 4.0625 19.8213 6.16117 19.8213 8.75C19.8213 11.3388 17.6627 13.4375 14.9999 13.4375C12.3371 13.4375 10.1785 11.3388 10.1785 8.75Z",
    fill: "#A81B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4287 17.1875C10.123 17.1875 8.2501 19.0084 8.2501 21.25V22.5C8.2501 23.3635 8.96909 24.0625 9.85725 24.0625H20.143C21.0311 24.0625 21.7501 23.3635 21.7501 22.5V21.25C21.7501 19.0084 19.8772 17.1875 17.5715 17.1875H12.4287ZM6.32153 21.25C6.32153 17.9729 9.0579 15.3125 12.4287 15.3125H17.5715C20.9423 15.3125 23.6787 17.9729 23.6787 21.25V22.5C23.6787 24.399 22.0962 25.9375 20.143 25.9375H9.85725C7.90397 25.9375 6.32153 24.399 6.32153 22.5V21.25Z",
    fill: "#A81B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRedIcon);
export default __webpack_public_path__ + "static/media/userRedIcon.7acbb9b8d6c769c45f1a6479feb788da.svg";
export { ForwardRef as ReactComponent };